import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import "../shuttle_bus_booking.css";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useDispatch, useSelector } from "react-redux";
import { SHUTTLE_BUS_BOOKING_SET_MAXIMUM_LIST, SHUTTLE_BUS_BOOKING_SET_MAXIMUM_UPDATE, SHUTTLE_BUS_BOOKING_SET_STATION_LIST } from "../../../routes";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";

import { TextBox } from "@progress/kendo-react-inputs";
import { createAndUpdateSetMaximum, fetchSetMaximumDetail } from "../../../store/shuttle_bus_booking/set_maximum";
import BackIcon from "../../../assets/communication/Back.svg";
import { createAndUpdateSetStation, fetchSetStationDetail } from "../../../store/shuttle_bus_booking/set_station";

export const ShuttleBusBookingSetStationAdd = () => {

  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);

  const [errors, setErrors] = useState(false);
  const [showRequiredFieldError, setShowRequiredFieldError] = useState(false);
  const [loading, setLoading] = useState(false);

  const [id, setId] = useState(
    query.get("id") ?? ""
  );

  const userPermissions = getUserPermission();

  const AddPermssion = checkPermission(
    userPermissions,
    "bus_booking.create_bus_booking_station"
  );

  const [editData, setEditData] = useState({
    station_name: "",
    longitude: "",
    latitude: "",
  });



  const { detail_data, detail_loading } = useSelector(
    (state) => state.shuttleBusSetStation
  );

  const getData = async () => {
    dispatch(fetchSetStationDetail(id));
  };


  useEffect(() => {
    getData();
  }, [id]);

  useEffect(() => {

    if (detail_data && id) {
      setEditData({
        station_name: detail_data.station_name,
        longitude: detail_data.longitude,
        latitude: detail_data.latitude,
      });
    }


  }, [detail_data]);



  const handleSubmit = () => {
    if (checkMandatoryFields()) return;

    setLoading(true);
    
    dispatch(createAndUpdateSetStation({ data: editData, id })).then((res) => {
      const { payload } = res;
      if (payload.status === "success") {

        setLoading(false);
        navigate(SHUTTLE_BUS_BOOKING_SET_STATION_LIST);

      } else {
        setLoading(false);


      }
    });


  };


  const checkMandatoryFields = () => {

    const { station_name, longitude, latitude } = editData;

    if ( !station_name || !longitude || !latitude) {
      console.error("All fields must be filled.");
      setShowRequiredFieldError(true);
      return true;
    }

    setShowRequiredFieldError(false);

    return false;
  }


  const callback_handleBackBtn = (e) => {

    navigate(SHUTTLE_BUS_BOOKING_SET_STATION_LIST);

  };


  return (
    <>
      {AddPermssion ? (
        <div style={{ height: "calc(100% - 75px)" }}>

          {errors && (
            <Dialog
              width={400}
              title={"Message"}
              onClose={() => setErrors(false)}
              className="error-message"
            >
              <p>{errors}</p>
            </Dialog>
          )}

          {showRequiredFieldError && (
            <Dialog
              className="information-details-alert-form"
              title={"Alert"}
              onClose={() => setShowRequiredFieldError(false)}
            >
              <p
                style={{
                  margin: "25px",
                  textAlign: "center",
                }}
              >
                Please fill in all the required fields.
              </p>
            </Dialog>
          )}



          {(detail_loading || loading) && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          <div className="shuttle_bus_booking_body">
            <div className="shuttle_bus_booking_addheader" >
              <div className="back-title-group" onClick={(e) => callback_handleBackBtn(e)}>
                <img src={BackIcon} className="back-icon" />
                <span className="back-text">Back</span>
              </div>
            </div>
          </div>

          <div className="main-shuttle-bus-container">
            <div className="main-poll-survey">

              <div className="shuttle_bus_booking_create_scroll_box">
                

                <div className="shuttle_bus_booking_create_item_main_box">
                  <div className="shuttle_bus_booking_create_item_main_box_title">
                    Station Name <span style={{ color: "red" }}>*</span>
                  </div>
                  <div>
                    <TextBox
                      className="shuttle_bus_booking_create_item_main_box_field"
                      value={editData.station_name}
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          station_name: e.target.value,
                        })
                      }
                    />

                  </div>
                </div>

                <div className="shuttle_bus_booking_create_item_main_box">
                  <div className="shuttle_bus_booking_create_item_main_box_title">
                    Latitude <span style={{ color: "red" }}>*</span>
                  </div>
                  <div>
                    <TextBox
                      className="shuttle_bus_booking_create_item_main_box_field"
                      value={editData.latitude}
                      type="number"
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          latitude: e.target.value,
                        })
                      }
                    />

                  </div>
                </div>

                <div className="shuttle_bus_booking_create_item_main_box">
                  <div className="shuttle_bus_booking_create_item_main_box_title">
                    Longitude <span style={{ color: "red" }}>*</span>
                  </div>
                  <div>
                    <TextBox
                      className="shuttle_bus_booking_create_item_main_box_field"
                      value={editData.longitude}
                      type="number"
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          longitude: e.target.value,
                        })
                      }
                    />

                  </div>
                </div>

              </div>
            </div>

            <div className="campaigns-survey-footer">
              <div className="footer-left-btn-groups">
                <Button
                  className="footer-previous-btn font-family-poppins"
                  onClick={() => {
                    navigate(SHUTTLE_BUS_BOOKING_SET_STATION_LIST);
                  }}
                >
                  Cancel
                </Button>
              </div>


              <div className="footer-right">


                <Button
                  className="footer-next-btn"
                  onClick={(e) => {
                    handleSubmit();
                  }}
                >
                  Submit
                </Button>
              </div>


            </div>
          </div>



        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
